import React from 'react'
import { Redirect, withRouter } from 'react-static'
import PropTypes from 'prop-types'
import Script from 'react-load-script'
import validate from 'validate.js'
import ContactFormModal from './ContactFormModal'
import { scrollToTop } from '../helpers'

class ContactForm extends React.Component {
  static propTypes = {
    isContact: PropTypes.bool
  }

  constructor() {
    super()
    this.state = {
      name: '',
      email: '',
      phone: '',
      message: '',
      nameValid: true,
      emailValid: true,
      phoneValid: true,
      messageValid: true,
      nameError: null,
      emailError: null,
      phoneError: null,
      messageError: null,
      modal: false,
      modalMessage: '',
      redirect: false
    }
    this.constraints = {
      name: {
        presence: true,
        format: {
          pattern: '[a-zA-Z ]+',
          flags: 'i',
          message: 'Please enter your name'
        }
      },
      email: {
        presence: true,
        email: {
          message: 'Please enter a valid email'
        }
      },
      phone: {
        numericality: {
          message: 'Please enter a valid contact number'
        }
      },
      message: {
        presence: true,
        length: {
          maximum: 500,
          message: 'Your message may only contain 500 characters'
        }
      }
    }
  }

  handleScriptError = script => {
    console.log(`${script} error`)
  }

  handleScriptLoad = script => {
    if (script === 'emailjs') {
      emailjs.init('user_2mNPJ81EyVF4nNZBvqStM') // eslint-disable-line
    }
  }

  handleFormChange = e => {
    const key = e.target.name
    const value = e.target.value
    this.setState({ [key]: value }, () => {
      this.validateSingle(key, value)
    })
  }

  validateSingle = (key, value) => {
    const validKey = `${key}Valid`
    const errorKey = `${key}Error`

    if (value === '') {
      this.setState({
        [validKey]: false,
        [errorKey]: `${key.charAt(0).toUpperCase() + key.slice(1)} can't be blank`
      })
    } else {
      this.setState({
        [validKey]: true,
        [errorKey]: null
      })
    }
  }
  handleSendClick = () => {
    const { name, email, message, phone } = this.state
    this.validateAll(name, email, phone, message)
  }
  validateAll = (name, email, phone, message) => {
    const error = validate({ name, email, phone, message }, this.constraints, {
      fullMessages: false
    })

    if (!error) {
      return this.sendEmail(name, email, phone, message)
    }

    if (error.name) {
      this.showError('name', error.name)
    }
    if (error.email) {
      this.showError('email', error.email)
    }
    if (error.phone) {
      this.showError('phone', error.phone)
    }
    if (error.message) {
      this.showError('message', error.message)
    }
  }

  showError = (key, error) => {
    const validKey = `${key}Valid`
    const errorKey = `${key}Error`

    this.setState({
      [validKey]: false,
      [errorKey]: error[0]
    })
  }

  sendEmail = (name, email, phone, message) => {
    this.setState({
      modal: true,
      modalMessage: 'One moment please...'
    })
    emailjs
      .send('makuch_roofing', 'makuch_roofing', {
        name,
        email,
        phone,
        message
      })
      .then(
        () => {
          this.displayModal("Message sent, we'll be in touch.", true)
        },
        () => {
          this.displayModal('Something went wrong, please try again.', false)
        }
      )
  }

  displayModal = (message, redirect) => {
    this.setState(
      {
        modal: true,
        modalMessage: message
      },
      () => {
        setTimeout(() => {
          if (redirect && this.props.isContact) {
            this.setState({ redirect: true })
          } else if (redirect && !this.props.isContact) {
            this.setState({
              modal: false,
              modalMessage: '',
              name: '',
              email: '',
              phone: '',
              message: ''
            })
            scrollToTop()
          } else {
            this.setState({
              modal: false,
              modalMessage: ''
            })
          }
        }, 1500)
      }
    )
  }

  render() {
    const {
      name,
      email,
      phone,
      message,
      nameValid,
      nameError,
      emailValid,
      phoneValid,
      emailError,
      phoneError,
      messageValid,
      messageError,
      redirect,
      modal,
      modalMessage
    } = this.state
    return (
      <div className="contact-form">
        <Script
          url="https://cdn.emailjs.com/dist/email.min.js"
          onError={() => this.handleScriptError('emailjs')}
          onLoad={() => this.handleScriptLoad('emailjs')}
        />
        <div>
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            name="name"
            id="name"
            value={name}
            className={!nameValid ? 'validation-error' : ''}
            onChange={this.handleFormChange}
          />
          <p className="validation-error-message">{nameError}</p>
        </div>
        <div>
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            name="email"
            id="email"
            value={email}
            className={!emailValid ? 'validation-error' : ''}
            onChange={this.handleFormChange}
          />
          <p className="validation-error-message">{emailError}</p>
        </div>
        <div>
          <label htmlFor="phone">Phone:</label>
          <input
            type="tel"
            name="phone"
            id="phone"
            value={phone}
            className={!phoneValid ? 'validation-error' : ''}
            onChange={this.handleFormChange}
          />
          <p className="validation-error-message">{phoneError}</p>
        </div>
        <div>
          <label htmlFor="message">Message:</label>
          <textarea
            name="message"
            id="message"
            cols="30"
            rows="10"
            value={message}
            className={!messageValid ? 'validation-error' : ''}
            onChange={this.handleFormChange}
          />
          <p className="validation-error-message">{messageError}</p>
        </div>
        <div>
          <button onClick={this.handleSendClick}>Send</button>
        </div>
        {modal && <ContactFormModal message={modalMessage} />}
        {redirect && <Redirect to="/" />}
      </div>
    )
  }
}

export default withRouter(ContactForm)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/ContactForm.js